import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  state: { 
    jwt: localStorage.getItem('t'),
    endpoints: {
      obtainJWT: 'https://stormy-mountain-29119.herokuapp.com/v3/auth/obtain_token/',
      refreshJWT: 'https://stormy-mountain-29119.herokuapp.com/v3/auth/refresh_token/',
    }
  },
  mutations,
  actions,
  getters,
}